import React, { Component } from 'react';
import Section from './layouts/Section';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt, faClock } from '@fortawesome/free-solid-svg-icons';
import { submitContactForm } from '../api/email';

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: ''
            },
            status: {
                submitting: false,
                success: false,
                error: null
            }
        };
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [name]: value
            }
        }));
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        
        this.setState(prevState => ({
            status: { 
                ...prevState.status, 
                submitting: true, 
                error: null,
                success: false
            }
        }));

        const result = await submitContactForm(this.state.formData);
        
        if (result.success) {
            this.setState({
                formData: {
                    name: '',
                    email: '',
                    phone: '',
                    subject: '',
                    message: ''
                },
                status: {
                    submitting: false,
                    success: true,
                    error: null
                }
            });
            
            setTimeout(() => {
                this.setState(prevState => ({
                    status: { ...prevState.status, success: false }
                }));
            }, 5000);
        } else {
            this.setState(prevState => ({
                status: {
                    ...prevState.status,
                    submitting: false,
                    success: false,
                    error: result.error
                }
            }));
            
            setTimeout(() => {
                this.setState(prevState => ({
                    status: { ...prevState.status, error: null }
                }));
            }, 5000);
        }
    }

    render() {
        const { formData, status } = this.state;
        return (
            <Section title={'Contact Us'}>
                <section className='section page-content'>
                    <div className='container'>
                        <div className="row">
                            {/* Contact Information */}
                            <div className="col-lg-4 mb-4 mb-lg-0">
                                <div className="contact-info p-4 bg-light rounded">
                                    <h3 className="mb-4">Get in Touch</h3>
                                    <div className="mb-4">
                                        <FontAwesomeIcon icon={faPhone} className="mr-3 text-primary" />
                                        <span>+1 (843) 900-4668</span>
                                    </div>
                                    <div className="mb-4">
                                        <FontAwesomeIcon icon={faEnvelope} className="mr-3 text-primary" />
                                        <span>info@iscreenfix.com</span>
                                    </div>
                                    <div className="mb-4">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-3 text-primary" />
                                        <span>981 Hackler Street Unit E, Myrtle Beach, SC 29577</span>
                                    </div>
                                    <div>
                                        <FontAwesomeIcon icon={faClock} className="mr-3 text-primary" />
                                        <span>Everyday: 10:00 AM - 6:00 PM</span>
                                    </div>
                                </div>
                            </div>

                            {/* Contact Form */}
                            <div className="col-lg-8">
                                <div className="contact-form p-4 bg-light rounded">
                                    <h3 className="mb-4">Send us a Message</h3>
                                    <h4 className="mb-4">Please provide some details about your device and the repair you would like to schedule.</h4>
                                    {status.success && (
                                        <div className="alert alert-success">
                                            Thank you for your message! We'll get back to you soon.
                                        </div>
                                    )}
                                    {status.error && (
                                        <div className="alert alert-danger">
                                            {status.error}
                                        </div>
                                    )}
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Your Name"
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={this.handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <input 
                                                    type="email" 
                                                    className="form-control" 
                                                    placeholder="Your Email"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={this.handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <input
                                                    type="tel"
                                                    className="form-control"
                                                    placeholder="Phone Number"
                                                    name="phone"
                                                    value={formData.phone}
                                                    onChange={this.handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Subject"
                                                    name="subject"
                                                    value={formData.subject}
                                                    onChange={this.handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <textarea 
                                                className="form-control" 
                                                rows="5" 
                                                placeholder="Your Message"
                                                name="message"
                                                value={formData.message}
                                                onChange={this.handleChange}
                                                required
                                            ></textarea>
                                        </div>
                                        <button 
                                            type="submit" 
                                            className="btn btn-primary"
                                            disabled={status.submitting}
                                        >
                                            {status.submitting ? 'Sending...' : 'Send Message'}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>

                        {/* Map Section */}
                        <div className="row mt-5">
                            <div className="col-12">
                                <div className="map-container rounded overflow-hidden">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3320.600297739893!2d-78.93843679999999!3d33.6675172!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89006a1ac882fa8d%3A0x5ebd3dcc52f00a4d!2siScreenFix!5e0!3m2!1sen!2sus!4v1743276246819!5m2!1sen!2sus" 
                                        width="100%" 
                                        height="450" 
                                        style={{ border: 0 }} 
                                        allowFullScreen="" 
                                        loading="lazy"
                                        title="maps"
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Section>
        );
    }
}

export default Contact;